// Карточка «Поддержка» в правой колонке ЛК.
// id="help" — таргет «Нужна помощь?» из карточки билета и линк в bottom-nav.
export const accountSupportSection = {
  anchorId: 'help',
  title: 'Поддержка',
  description:
    'Не пришло письмо, нужна замена данных или вопрос по проходу.',
  links: [
    {
      label: 'org@forum-industry.ru',
      href: 'mailto:org@forum-industry.ru'
    },
    {
      label: 'Написать в MAX',
      href: 'https://max.ru/u/f9LHodD0cOJ1otgVx9KGa4maaCIVqQH5TX7X3JwN8a8incQQs69OylZpCCU',
      external: true
    }
  ]
};

// Тексты мобильной нижней навигации (видна только на ≤767px).
export const accountBottomNav = {
  ariaLabel: 'Мобильная навигация кабинета',
  items: [
    { label: 'Билет', href: '#ticket-title', active: true },
    { label: 'Профиль', href: '#profile-title' },
    { label: 'Программа', href: '/#program' },
    { label: 'Помощь', href: '#help' }
  ]
};
